import { render, staticRenderFns } from "./signdetail.vue?vue&type=template&id=10c8b0c6&"
import script from "./signdetail.vue?vue&type=script&lang=js&"
export * from "./signdetail.vue?vue&type=script&lang=js&"
import style0 from "./signdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports